import config from 'message-control/config'

const apiHost = `${config.apiHost}/oem-crm_new_java`

export default {
    getList: {
        url: `${apiHost}/api/customer-service/kpi/rule`,
        type: 'GET',
    },
    postRule: {
        url: `${apiHost}/api/customer-service/kpi/rule`,
        type: 'POST',
    },
    deleteRule: {
        url: `${apiHost}/api/customer-service/kpi/rule/{id}`,
        type: 'DELETE',
    },
    getAssessWord: {
        url: `${apiHost}/api/customer-service/kpi/assess-word`,
        type: 'GET',
    },
    postAssessWord: {
        url: `${apiHost}/api/customer-service/kpi/assess-word`,
        type: 'POST',
    },
}
